import * as z from "zod";
import { NotionProductKnowledgeEditSummary } from "./list-product-knowledge-edits";

const NotionProductKnowledgeEditFull = NotionProductKnowledgeEditSummary.extend(
  { unifiedDiff: z.string().nullable() },
);

export const getProductKnowledgeEdit = {
  name: "getProductKnowledgeEdit" as const,
  input: z.object({ id: z.string() }),
  output: NotionProductKnowledgeEditFull.nullable(),
};
